export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-pinterest-d7e7d1f3e23a8e097cd4ecfbda6baa27.svg";